module.exports = __webpack_public_path__ + "static/media/icon_speaker_on.557973fe.svg";